var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndoneStepReviewSubmit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4816_78013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.5475 25.2987L31.5007 24.5876C33.2251 23.9597 34.0873 23.6458 34.1121 23.0511C34.1368 22.4565 33.3037 22.072 31.6375 21.3029L21.2069 16.4888C17.5357 14.7944 15.7001 13.9472 14.8235 14.8237C13.947 15.7003 14.7942 17.5359 16.4886 21.2071L21.3027 31.6377C22.0717 33.3039 22.4563 34.1371 23.0509 34.1123C23.6456 34.0875 23.9595 33.2253 24.5873 31.5009L25.2985 29.5478C25.8563 28.0158 26.1352 27.2498 26.6924 26.6926C27.2496 26.1354 28.0156 25.8565 29.5475 25.2987Z",
    stroke: "#707070",
    strokeWidth: 1.77778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4816_78013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoneStepReviewSubmit);
export default __webpack_public_path__ + "static/media/undone-step-review-submit.12859f81ba2de32004a8b4d7bf0ae385.svg";
export { ForwardRef as ReactComponent };